module.exports = __webpack_public_path__ + "img/aw.d536ae24.svg";